import { CSSProperties, FC } from 'react';
import { BendHelpLine } from 'helpers/config/constants';

interface Props {
  children: React.ReactNode;
  className?: string;
  style?: CSSProperties;
}

export const BendHelpLineLink = () => {
  return <a href={`tel:${BendHelpLine.rawNum}`}>{BendHelpLine.formattedNum}</a>;
};

export const BendHelpLineLinkWrapper: FC<Props> = ({
  children,
  className,
  style,
}) => {
  return (
    <a className={className} href={`tel:${BendHelpLine.rawNum}`} style={style}>
      {children}
    </a>
  );
};
